import { render, staticRenderFns } from "./ReportTabsHomeWidget.vue?vue&type=template&id=a2d16854&scoped=true"
import script from "./ReportTabsHomeWidget.vue?vue&type=script&lang=js"
export * from "./ReportTabsHomeWidget.vue?vue&type=script&lang=js"
import style0 from "./ReportTabsHomeWidget.vue?vue&type=style&index=0&id=a2d16854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d16854",
  null
  
)

export default component.exports